import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Button, Text, Badge } from "@fluentui/react-components";
import { ArrowExitRegular, BookOpenRegular } from "@fluentui/react-icons";
import { SideNav } from "./SideNav";
import { ApprobateursView } from "../views/Approbateurs/ApprobateursView";
import { PlanningApprobations } from "../views/Planning/PlanningApprobations";
import { SalariesView } from "../views/Salaries/SalariesView";
import { ConfigurationView } from "../views/Configuration/ConfigurationView";
import { ServiceView } from "../views/Services/ServiceView";
import { useAuth } from "../../context/AuthContext";
import { useRole } from "../../context/RoleContext";
import { FormationProvider, useFormation } from "../Formation/FormationContext";
import { TourGuide } from "../Formation/TourGuide";
import { FormationCenter } from "../Formation/FormationCenter";
import { RoleSwitcher } from "../common/RoleSwitcher";
import { LieuSelector } from "../common/LieuSelector";
const AppLayoutInner = ({ onSwitchToEmployee }) => {
    const [activeView, setActiveView] = useState("planning");
    const [ficheEmployeeEmail, setFicheEmployeeEmail] = useState("");
    const [selectedPlanningEmail, setSelectedPlanningEmail] = useState("");
    const [showFormation, setShowFormation] = useState(false);
    const { userName, userEmail } = useAuth();
    const { role } = useRole();
    const { progressions } = useFormation();
    // Première visite : ouvrir le centre de formation automatiquement
    useEffect(() => {
        if (progressions.length === 0 && !localStorage.getItem("rh-formation-seen")) {
            const timer = setTimeout(() => {
                setShowFormation(true);
                localStorage.setItem("rh-formation-seen", "true");
            }, 1500);
            return () => clearTimeout(timer);
        }
    }, [progressions.length]);
    const navigateToFiche = (email) => {
        setFicheEmployeeEmail(email);
        setActiveView("salaries");
    };
    const renderView = () => {
        switch (activeView) {
            case "approbations": return _jsx(PlanningApprobations, { defaultTab: "demandes", onNavigateToFiche: navigateToFiche, initialSelectedEmail: selectedPlanningEmail, onSelectedEmailChange: setSelectedPlanningEmail });
            case "planning": return _jsx(PlanningApprobations, { defaultTab: "planning", onNavigateToFiche: navigateToFiche, initialSelectedEmail: selectedPlanningEmail, onSelectedEmailChange: setSelectedPlanningEmail });
            case "salaries": return _jsx(SalariesView, { initialFicheEmail: ficheEmployeeEmail, onClearFiche: () => setFicheEmployeeEmail("") });
            case "services": return _jsx(ServiceView, {});
            case "approbateurs": return _jsx(ApprobateursView, {});
            case "administration": return _jsx(ConfigurationView, {});
        }
    };
    const handleNavigate = (view) => {
        setActiveView(view);
        if (view !== "salaries")
            setFicheEmployeeEmail("");
    };
    return (_jsxs("div", { style: { display: "flex", minHeight: "100vh", width: "100%" }, children: [_jsx(SideNav, { activeView: activeView, onNavigate: handleNavigate }), _jsxs("div", { style: { flex: 1, display: "flex", flexDirection: "column" }, children: [_jsxs("header", { style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "12px 32px",
                            borderBottom: "1px solid #e0e0e0",
                            backgroundColor: "#fff",
                        }, children: [_jsx(Text, { size: 400, weight: "semibold", children: "AVH - Portail RH" }), _jsxs("div", { style: { display: "flex", alignItems: "center", gap: "12px" }, children: [_jsx(Button, { size: "small", appearance: "subtle", icon: _jsx(BookOpenRegular, {}), onClick: () => setShowFormation(true), title: "Centre de formation", children: "Aide & Formation" }), onSwitchToEmployee && (_jsx(Button, { size: "small", appearance: "subtle", icon: _jsx(ArrowExitRegular, {}), onClick: onSwitchToEmployee, children: "Mon espace" })), _jsx(LieuSelector, {}), _jsx(RoleSwitcher, {}), _jsx(Badge, { appearance: "outline", color: role === "Admin" ? "danger" : role === "SuperUser" ? "important" : "informative", children: role }), _jsxs(Text, { size: 200, children: [userName, " (", userEmail, ")"] })] })] }), _jsx("main", { style: { flex: 1, padding: "24px 32px", overflow: "auto" }, children: showFormation ? (_jsx(FormationCenter, { portailType: "RH", onClose: () => setShowFormation(false), onNavigate: (view) => { handleNavigate(view); setShowFormation(false); } })) : (renderView()) })] }), _jsx(TourGuide, {})] }));
};
export const AppLayout = (props) => (_jsx(FormationProvider, { portailType: "RH", children: _jsx(AppLayoutInner, { ...props }) }));
